module.exports = __webpack_public_path__ + "static/Path5-000eff779db1297e20e3645168c45208.svg";